module.exports = __webpack_public_path__ + "static/media/carte_france_3jaunes.7a2f4cb5.svg";